import type { ComponentProps } from "react"

export default function IndustryL(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M24 14.6667H26.6667V17.3334H24V14.6667ZM24 20.0001H26.6667V22.6667H24V20.0001Z"
        fill={fill}
      />
      <path
        d="M31.708 9.83342L26.3747 3.16675C26.3747 3.16675 26.36 3.15875 26.3547 3.15208C26.2304 3.00129 26.0745 2.87965 25.898 2.79578C25.7215 2.71191 25.5287 2.66786 25.3333 2.66675H14.6667C14.4667 2.66667 14.2693 2.71157 14.089 2.79812C13.9088 2.88467 13.7503 3.01066 13.6253 3.16675L8.292 9.83342C8.10284 10.07 7.99986 10.3639 8 10.6667V16.6667H13.3333C13.7711 16.6667 14.2046 16.7528 14.6091 16.9203C15.0135 17.0877 15.3811 17.3332 15.6907 17.6427L19.6907 21.6427C20.0002 21.9523 20.2457 22.3199 20.4131 22.7243C20.5806 23.1288 20.6667 23.5623 20.6667 24.0001V28.0001H30.6667C31.0203 28.0001 31.3594 27.8596 31.6095 27.6096C31.8595 27.3595 32 27.0204 32 26.6667V10.6667C32.0001 10.3639 31.8972 10.07 31.708 9.83342ZM29.3333 25.3334H21.3333V11.1347L25.3333 6.13341L29.3333 11.1334V25.3334Z"
        fill={fill}
      />
      <path
        d="M18.276 23.0574L14.276 19.0574C14.0183 18.8191 13.6841 18.6805 13.3333 18.6667H5.33333C4.97974 18.6668 4.64066 18.8073 4.39067 19.0574L0.390667 23.0574C0.151811 23.3147 0.0131932 23.6492 0 24.0001L0 30.6667C0 31.0204 0.140476 31.3595 0.390524 31.6096C0.640573 31.8596 0.979711 32.0001 1.33333 32.0001H17.3333C17.687 32.0001 18.0261 31.8596 18.2761 31.6096C18.5262 31.3595 18.6667 31.0204 18.6667 30.6667V24.0001C18.6666 23.6465 18.5261 23.3074 18.276 23.0574ZM16 29.3334H10.6667V24.5521L13.3333 21.8854L16 24.5521V29.3334Z"
        fill={fill}
      />
    </svg>
  )
}
